import { CalendarEventType, CalendarEventTypeValue } from '@/app/planning/enums/CalendarEventType';

export default () => {
    return CalendarEventTypeValue.map((type) => new CalendarEventType(type));
};
